module.exports = __webpack_public_path__ + "static/media/idcardback.b6aacc01.png";